import { ownStore } from "../AppOwnState/ownState";

let currentLang = "en-US";

export function setLanguage(lang) {
    currentLang = lang;
}

export function t(text) {
    const glbDict = ownStore?.getState("GDSdictionary");
    const userCulture = ownStore.getState("_userinfo");

    currentLang = userCulture?.userculture || "en-US"

    if (!glbDict || !glbDict[0]?.dictionary) return text;

    let dictionary = [];
    try {
        dictionary = JSON.parse(glbDict[0].dictionary) || [];
    } catch {
        return text;
    }

    const entry = dictionary.find((item) => item["en-US"] === text);
    if (!entry) return text;

    return entry[currentLang] || entry["en-US"];
}
